import React from 'react'
import { Tag } from 'antd'

export const PushTab: React.FC = () => {
  return <Tag>In development</Tag>
}
